import "./Element.css"
const Element = (props) =>{
    const {element} = props
    return(
        element &&
        <div className="element">
            <p className="name" dangerouslySetInnerHTML={{__html:element.name}}></p>
            <p className="english_name">
                {element.english_name}
            </p>
            {element.location && 
            <div className="location-container">
                <img src={require("../assets/ubicacion.png")} alt="Ubicacion"/>
                <span>{element.location}</span>
            </div>
            }
            {element.date && 
            <div className="date">
                <span>{element.date}</span>
            </div>
            }
            <div className="image-container">
                <img src={require(`../assets/img/${element.img}`)} alt={element.name}/>
            </div>
            <div className="description-container">
                <div className="description" dangerouslySetInnerHTML={{__html:element.desc}}></div>
                <div className="description english" dangerouslySetInnerHTML={{__html:element.english_desc}}></div>
            </div>
        </div>
    )
}

export default Element;